import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import {
  Button,
  NavBar,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Popup,
  Icon,
  Field,
  Tabs,
  Tab,
  Loading,
  Progress,
  CountDown,
  Image as VanImage,
  Skeleton,
  Toast
} from 'vant'
import 'vant/lib/index.css'

import './styles/common.scss'

import util from './utils/util'
import filters from './utils/filters'
import i18n, { LANGUAGES } from './locales'

const app = createApp(App)

app.use(Button)
app.use(NavBar)
app.use(Tabbar)
app.use(TabbarItem)
app.use(Swipe)
app.use(SwipeItem)
app.use(Popup)
app.use(Icon)
app.use(Field)
app.use(Tabs)
app.use(Tab)
app.use(Loading)
app.use(Progress)
app.use(CountDown)
app.use(VanImage)
app.use(Skeleton)
app.use(Toast)
app.use(store)
app.use(router)
app.use(i18n)

app.config.globalProperties.$util = util
app.config.globalProperties.$filters = filters

// 挂载语言切换方法，供组件使用
app.config.globalProperties.$setLocale = function(lang) {
  i18n.global.locale.value = lang
  localStorage.setItem('language', lang)
  store.dispatch('setLanguage', lang)
}

app.config.globalProperties.$getLocale = function() {
  return i18n.global.locale.value
}

app.config.globalProperties.$getLanguages = function() {
  return LANGUAGES
}

app.mount('#app')
